export class UpdateAccountLabelsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "labels",
            "baseName": "labels",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateAccountLabelsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
